import React from 'react';
import { Button, Fade, Stack, Typography } from '@mui/material';
import { useInstantSearchDataGridContext } from '@/components/tables/InstantSearchDataGrid';
import { getSearchRecordPath } from '@/components/tables/InstantSearchDataGrid/data';
import { usePreviewMode } from '@/hooks/usePreviewMode';
import { paths } from '@/app/routes';
import FolioLink from '@/components/FolioLink';

const DataGridDealName = ({ row }) => {
	const { openPreview, closePreview, previewId } = usePreviewMode();
	const { hoveredRowId, variant, showPreview } = useInstantSearchDataGridContext();

	const isDebtorsPipeline =
		variant === paths.debtors || row.pipeline === process.env.REACT_APP_PIPELINE_DEBTORS;
	const showButton = hoveredRowId === row.id && !(isDebtorsPipeline && row.policiesLoading);
	const dealPath = getSearchRecordPath(row);

	const handlePreview = (e) => {
		e.stopPropagation();

		const hasPreview = previewId;
		if (hasPreview) closePreview();
		setTimeout(() => openPreview(row.id), hasPreview ? 200 : 1);
	};

	const name = (
		<Typography
			sx={(theme) => ({
				color: theme.palette.primary.main,
				fontWeight: 600,
				'&:hover': {
					textDecoration: dealPath ? 'underline' : 'none',
				},
			})}
		>
			{row.dealName ?? 'Deal not found'}
		</Typography>
	);

	return (
		<Stack direction='row' width='100%' justifyContent='space-between' alignItems='center'>
			{dealPath ? (
				<FolioLink to={dealPath} stopPropagation sx={{ minWidth: 0, overflow: 'hidden' }}>
					{name}
				</FolioLink>
			) : (
				name
			)}
			{showPreview && (
				<Fade in={showButton} timeout={{ enter: 50, exit: 50 }}>
					<Button
						data-deal-preview-trigger
						onClick={handlePreview}
						variant='contained'
						size='small'
						sx={{ minWidth: 'auto' }}
					>
						Preview
					</Button>
				</Fade>
			)}
		</Stack>
	);
};

export default DataGridDealName;
